import wx from "@/assets/js/jweixin"
// import wx from "weixin-js-sdk"
import Axios from '@/utils/Axios.js'

// 微信JS工具类
class WxJs {
  constructor() { }
  /* 执行JS配置 */
  config (currentUrl, callback) {
    let url = currentUrl ? currentUrl : location.href;
    Axios.get("/api/wx/getWxJsConfig", {
      params: {
        url: url
      }
    }).then(res => {
      let wxRegParm = {
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        debug: false,
        // 必填，公众号的唯一标识
        appId: res.data.appId,
        // 必填，生成签名的时间戳
        timestamp: res.data.timestamp,
        // 必填，生成签名的随机串
        nonceStr: res.data.nonceStr,
        // 必填，签名
        signature: res.data.signature,
        // 必填，需要使用的JS接口列表
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getNetworkType', 'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem', 'closeWindow', 'scanQRCode', 'chooseWXPay', 'openProductSpecificView', 'addCard', 'chooseCard', 'openCard', 'openEnterpriseChat', 'openEnterpriseContact', 'getNetworkType', 'updateAppMessageShareData', 'updateTimelineShareData']
      };
      console.log("微信JSSDK注册：" + url + "\r\n" + JSON.stringify(wxRegParm));
      wx.config(wxRegParm);
      wx.ready(() => {
        //屏蔽微信右上角所有非基础按钮
        wx.hideAllNonBaseMenuItem();
        //要显示的菜单项
        wx.showMenuItems({
          menuList: ["menuItem:copyUrl", "menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:favorite"]
        });
        // 执行回调
        if (callback) {
          callback();
        }
      });
    });
  }
  /*  */
  setShare (shareData, currentUrl) {
    this.config(currentUrl, () => {
      //屏蔽微信右上角所有非基础按钮
      wx.hideAllNonBaseMenuItem();
      //要显示的菜单项
      wx.showMenuItems({ menuList: ["menuItem:copyUrl", "menuItem:share:appMessage", "menuItem:share:timeline", "menuItem:favorite"] });
      //分享给朋友
      wx.onMenuShareAppMessage(shareData);
      //分享朋友圈
      wx.onMenuShareTimeline(shareData);
    });
  }
  hideAllMenu () {
    this.config(window.location.href, () => {
      wx.hideAllNonBaseMenuItem();
    });
  }
}
export default new WxJs();



// WEBPACK FOOTER //
// ./src/utils/WxJs.js